import {PortalUserMin, UserId} from "platformed-client/types";

export const extractUserId = (pu: PortalUserMin): UserId => {
  return pu.info.type === "InvitePending" ? pu.info.content.user_id : pu.info.content.user.user_id;
};

export const extractEmail = (pu: PortalUserMin): string => {
  return pu.info.type === "InvitePending" ? pu.info.content.email : pu.info.content.user.primary_email;
};
